module.exports = __webpack_public_path__ + "img/darwinBlack.fca73ad1.png";